/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Purchase_2Inputs */

const en_flow_purchase_2 = /** @type {(inputs: Flow_Purchase_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The supplier confirms it in Atelier, or proposes a date.`)
};

/**
* | output |
* | --- |
* | "The supplier confirms it in Atelier, or proposes a date." |
*
* @param {Flow_Purchase_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_purchase_2 = /** @type {((inputs?: Flow_Purchase_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Purchase_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_purchase_2(inputs)
});